import React from 'react'
import { Icon, l } from '@manychat/manyui'

import { WarningLayoutFBPolicyProps } from './interfaces'

import cm from './WarningLayoutFBPolicy.module.css'

export const WarningLayoutFBPolicy = ({ count, label }: WarningLayoutFBPolicyProps) => (
  <div className="o-hidden">
    <div className="row gutter p-x p-y-xs">
      <Icon.Warning
        className="text-warning"
        size={16}
        style={{ position: 'relative', top: '5px' }}
        data-title={l.translate(
          'Kindly note that this filter will be converted into the “Outside 24 hour window” filter after March 4th, 2020 according to the Facebook policy update.',
        )}
      />
      <div className={cm.optionLabel}>{label}</div>
      <div className="col-auto text-secondary">{count}</div>
    </div>
  </div>
)
